export default "__VITE_PUBLIC_ASSET__c186e68b__"